import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		padding: `${THEME.spacing.sm}px 0`,
		fontSize: THEME.typography.fontSizes.sm,
	},
	row: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
		flexWrap: 'wrap' as const,
	},
	// "Only show when [question] is" — the leading label, checkbox + source
	// picker. The picker (`fill`) grows to fill the row's free space.
	conditionGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		flex: 1,
		minWidth: 0,
	},
	// A flex child that grows AND can shrink below its content width, so the
	// Combobox inside ellipsises instead of forcing the row wider / wrapping.
	fill: {
		flex: 1,
		minWidth: 0,
	},
	// The source/answer Comboboxes flex-fill their column. `width: 100%` lets
	// them grow to take all available space; long labels still truncate (the
	// input ellipsises overflow text) because the flex parent bounds the width
	// (`flex: 1; min-width: 0`).
	sourceComboboxInput: {
		width: '100%',
	},
	// Truncates long option labels inside a Combobox item (paired with bs.truncateText).
	comboboxItemLabel: {
		flex: 1,
		minWidth: 0,
	},
	answerColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		// Cap the answers column at 40% so the condition group (flex: 1) keeps the
		// larger ~60% share — otherwise the inline "Only show when"/"is" labels
		// leave the source-question combobox narrower than the answer combobox.
		flex: '0 1 40%',
		minWidth: 0,
	},
	answerRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		flex: 1,
		minWidth: 0,
	},
	orRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	orLabel: {
		color: THEME.colors.text.light,
		fontStyle: 'italic',
		position: 'absolute',
		transform: `translateX(calc(-100% - ${THEME.spacing.sm}px))`,
	},
	addAnswerButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		color: THEME.colors.primary.main,
		padding: 0,
		fontSize: THEME.typography.fontSizes.sm,
		textAlign: 'left' as const,
	},
	answerRemoveButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		padding: 0,
		lineHeight: 1,
		display: 'inline-flex',
		alignItems: 'center',
		color: THEME.colors.text.light,
	},
});
